export {default as LearningSkeleton} from './learning-skeleton' 